















































































































































































































































































































import { faPaperPlane, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { mapGetters, mapMutations, mapState } from 'vuex'
import CFormMixin from '~/components/shared/configurable/mixin/CFormMixin.vue'
import CEmailInput from '~/components/shared/configurable/form/input/CEmailInput.vue'
import CInternationalTelephoneInput from '~/components/shared/configurable/form/input/CInternationalTelephoneInput.vue'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CRecaptchaText from '~/components/shared/configurable/CRecaptchaText.vue'
import MiniAttachmentUploader from '~/components/car/classifieds/view/partials/MiniAttachmentUploader.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import {
  SET_CONTACT_SCHEMA,
  SET_SHOW_CONTACT,
  SET_SHOW_CONTACT_PROMPT,
  SET_CONTACT_FORM_DATA,
  SET_MESSAGE_STATS
} from '~/store/modules/shared/classifieds/view/mutation-types'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import {
  FallbackWidgetRenderResult,
  RecaptchaFormToken
} from '~/models/recaptcha/types'
import { APP_NS } from '~/store/modules/shared/app/state'
import RecaptchaService from '~/services/recaptcha/RecaptchaService'
import { toSnakeCase } from '~/utils/snake-case'
import { objectsEqual, toCamelCase } from '~/utils/object'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import TradeVehicleInMessages from '~/components/car/classifieds/TradeVehicleInMessages.vue'
import { CategoryId } from '~/models/category/types'
import { defineComponentTranslations } from '~/utils/i18n'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CInternationalTelephoneInput,
    CEmailInput,
    CFormError,
    CRecaptchaText,
    MiniAttachmentUploader,
    CTextArea,
    TradeVehicleInMessages
  },
  mixins: [CFormMixin],
  props: {
    classifiedId: { type: Number, default: null },
    classifiedUserId: { type: Number, default: null },
    ownedDealers: {
      type: Array,
      default() {
        return []
      }
    },
    websiteName: { type: String, default: null },
    websiteUserId: { type: Number, default: null },
    replyMsg: { type: Object, default: null },
    ownerId: { type: Number, default: null },
    loginAsUrl: { type: String, default: null },
    loginAsName: { type: String, default: null },
    inIframe: { type: Boolean, required: false, default: false },
    siteUrl: { type: String, required: false, default: 'car.gr' },
    extraText: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    useStore: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      icons: {
        paperPlane: faPaperPlane,
        pencilAlt: faPencilAlt
      },
      sendSuccess: false,
      form: {},
      getSchemaPath: 'data.schema',
      getDataPath: 'data.values',
      method: 'post',
      disableButton: false,
      errorList: [],
      prefill: null,
      uploading: false,
      showRecaptcha2: false,
      recaptcha2Loaded: false,
      selectedMakesValues: [],
      isTradeVehicleVisible: true
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userId: 'id',
      userActualName: 'name',
      username: 'username'
    }),
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin',
      isAnon: 'isAnon',
      isSingle: 'isSingle',
      isGuest: 'isGuest'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      contactFormData: state => toSnakeCase(state.contactFormData),
      categoryIds: state => state.classified.category_ids,
      messageStats: state => state.messageStats
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isPlotClassified: 'isPlotClassified',
      isJobOffered: 'isJobOffered',
      getClassifiedCode: 'getClassifiedCode',
      isOwn: 'isOwn',
      isWantedPartsClassified: 'isWantedPartsClassified'
    }),
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      isWantedPartsSearch: 'isWantedPartsSearch'
    }),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    }),

    url() {
      return `/api/classifieds/${this.classifiedId}/contact/`
    },
    userSettingsUrl() {
      const accountSettingsUrl = this.$router.resolve({
        name: '__account_settings'
      }).href

      if (this.isPlot) {
        if (this.isGuest) {
          return '/account/'
        }
        return accountSettingsUrl
      }
      return accountSettingsUrl
    },
    addPropertyCodeToMessage() {
      if (this.isPlotClassified && this.getClassifiedCode)
        return (
          this.$t('and property code').toLowerCase() +
          ' ' +
          this.getClassifiedCode +
          '\n'
        )
      return ''
    },
    isManager() {
      if (
        this.prefill &&
        this.prefill.dealers &&
        this.prefill.dealers.length > 2
      ) {
        return true
      }
      return false
    },
    isCarCategory() {
      return this.categoryIds?.includes(CategoryId.CARS)
    },
    isBikeCategory() {
      return this.categoryIds?.includes(CategoryId.BIKES)
    },
    classifiedType() {
      if (this.isCarCategory) {
        return 'cars'
      } else if (this.isBikeCategory) {
        return 'bikes'
      }
      return ''
    },
    classifiedMine() {
      // if we are dispatched
      if (
        process.client &&
        window.frameElement &&
        window.frameElement.getAttribute('clsfd-mine')
      ) {
        return window.frameElement.getAttribute('clsfd-mine') === 'True'
      }

      // if we are in car2
      if (this.isOwn) {
        return true
      }

      return false
    },
    managerOptions() {
      if (this.isManager) {
        const opts = [
          {
            text:
              this.prefill.dealers[0].name + ' (' + this.$t('manager') + ')',
            value: this.prefill.dealers[0].id
          }
        ]

        for (let i = 1; i < this.prefill.dealers.length; i++) {
          opts.push({
            text: this.prefill.dealers[i].name,
            value: this.prefill.dealers[i].id
          })
        }

        return opts
      }
      return null
    },
    messageTemplate() {
      return this.$t(
        this.isWantedPartsClassified || this.isWantedPartsSearch
          ? 'wanted_parts_message_template'
          : 'message_template',
        {
          siteUrl: this.siteUrl,
          classifiedId: this.classifiedId
        }
      )
    },
    responseTime() {
      if (this.messageStats?.replyTimeMedian) {
        const minutes = Math.round(this.messageStats.replyTimeMedian)

        const years = Math.floor(minutes / 525600) // 1 year = 525600 minutes
        const months = Math.floor((minutes % 525600) / 43800) // 1 month = 43800 minutes
        const weeks = Math.floor(((minutes % 525600) % 43800) / 10080) // 1 week = 10080 minutes
        const days = Math.floor((((minutes % 525600) % 43800) % 10080) / 1440) // 1 day = 1440 minutes
        const hours = Math.floor(
          ((((minutes % 525600) % 43800) % 10080) % 1440) / 60
        )

        if (years > 0)
          return `${years} ${this.$tc('year | years', years).toLowerCase()}`
        if (months > 0)
          return `${months} ${this.$tc('month | months', months).toLowerCase()}`
        if (weeks > 0)
          return `${weeks} ${this.$tc('week | weeks', weeks).toLowerCase()}`
        if (days > 0)
          return `${days} ${this.$tc('day | days', days).toLowerCase()}`
        if (hours > 0)
          return `${hours} ${this.$tc('hour | hours', hours).toLowerCase()}`
        if (minutes > 0)
          return `${minutes} ${this.$tc(
            'minute | minutes',
            minutes
          ).toLowerCase()}`
      }
      return null
    },
    isResponseTimeVisible() {
      const replyTimeMinutes = this.messageStats?.replyTimeMedian

      if (!replyTimeMinutes) {
        return false
      }

      const replyTimeDays = Math.floor(replyTimeMinutes / 60 / 24)

      return this.isAdmin || replyTimeDays <= 4
    }
  },
  watch: {
    form: {
      handler(val) {
        if (this.useStore) {
          this.setContactFormData(val)
        }
      },
      deep: true
    },
    contactFormData: {
      handler(val, oldVal) {
        if (this.useStore && !objectsEqual(val, oldVal)) {
          const tmpFormData = { ...val }
          if (val?.success) {
            this.sendSuccess = val.success
          }
          delete tmpFormData.success
          this.$set(this, 'form', tmpFormData)
        }
      }
    }
  },
  updated() {
    this.$nextTick(function() {
      this.$emit('contact-update')
    })
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setShowContact: SET_SHOW_CONTACT,
      setContactSchema: SET_CONTACT_SCHEMA,
      setMessageStats: SET_MESSAGE_STATS,
      setContactPrompt: SET_SHOW_CONTACT_PROMPT,
      setContactFormData: SET_CONTACT_FORM_DATA
    }),
    preprocessForm(form) {
      form.body += this.extraText
      return form
    },
    onDataGet(d) {
      if (this.schema === null) {
        // something weird happened, so hide the form
        if (this.isSingle && this.isOwn && d.data.has_messages_for_classified) {
          this.setShowContact(true)
          this.$emit('what-to-show', 'messages-only')
        } else {
          this.setShowContact(false)
        }

        if (
          this.isAnon ||
          (this.isSingle && !this.isOwn && !d.data.has_messages_for_classified)
        ) {
          this.setContactPrompt(true)
        }

        this.$emit('schema-null')
        return
      } else {
        this.setShowContact(true)
        this.setContactSchema(true)
        this.setContactPrompt(false)

        if (d.data.message_stats) {
          this.setMessageStats(toCamelCase(d.data.message_stats))
        }
        this.isTradeVehicleVisible = d.data.can_trade_in_message
      }

      if (d.data.values) {
        this.prefill = d.data.values
        if (this.prefill.telephone) {
          if (this.prefill.telephone.code === 30) {
            this.prefill.telephone.with_code = this.prefill.telephone.telephone
          } else {
            this.prefill.telephone.with_code =
              '+' +
              this.prefill.telephone.code +
              '' +
              this.prefill.telephone.telephone
          }
        }

        if (this.prefill.dealers && this.prefill.dealers.length === 2) {
          // means we are not manager
          const userToChange = this.prefill.dealers[1]
          this.form.sender_id = userToChange.id
          this.form.name = userToChange.name
          this.form.email = userToChange.email
          this.form.telephone = userToChange.telephone
        }
      }

      if (d.data.has_messages_for_classified) {
        if (this.isAdmin) {
          this.$emit('what-to-show', 'both')
        } else {
          this.$emit('what-to-show', 'messages-only')
        }
      } else {
        this.$emit('what-to-show', 'contact-only')
      }

      this.form.body = this.messageTemplate
    },
    senderChange(id) {
      let userToChange = null
      this.form.sender_id = id
      if (id === null) {
        userToChange = this.prefill.dealers[0]
      } else {
        for (let i = 0; i < this.prefill.dealers.length; i++) {
          if (id === this.prefill.dealers[i].id) {
            userToChange = this.prefill.dealers[i]
            break
          }
        }
      }

      this.form.name = userToChange.name
      this.form.email = userToChange.email
      this.form.telephone = userToChange.telephone
    },
    onSuccess() {
      this.sendSuccess = true
      if (this.useStore) {
        this.setContactFormData({ ...this.form, success: true })
      }
    },
    async onError(errors) {
      if (errors.recaptcha_token && !this.showRecaptcha2) {
        this.showRecaptcha2 = true
        this.disableButton = true

        if (!this.recaptcha2Loaded) {
          const recaptchaService = this.$dep(RecaptchaService)
          this.recaptcha2Loaded = true
          await this.$nextTick()
          this.isLoading = false
          const {
            token
          }: FallbackWidgetRenderResult = await recaptchaService.renderFallbackWidget(
            'g-recaptcha'
          )
          this.disableButton = false
          this.form.recaptcha_token = {
            v: 2,
            token
          } as RecaptchaFormToken
        }
      }
    },
    async submitMessage() {
      this.isLoading = true
      if (!this.showRecaptcha2) {
        try {
          const recaptchaService = this.$dep(RecaptchaService)
          const token = await recaptchaService.getToken('contact_form')
          this.form.recaptcha_token = {
            v: 3,
            token
          }
          this.submit()
        } catch (e) {
          // this will force load recaptcha 2
          this.onError({ recaptcha_token: true })
          this.$logger.captureError(e)
        }
      } else {
        this.submit()
      }
    },
    checkButtonState() {
      if (this.form.body === '') {
        this.disableButton = true
      } else if (this.disableButton) {
        this.disableButton = false
      }
    },
    onResponseError(response, code) {
      if (code === 429 && this.errorList.length === 0) {
        this.errorList.push(
          this.$t("you've sent too many messages, please try again later")
        )
      }

      if (response.response.data.error) {
        this.errorList.push(response.response.data.error)
      } else {
        this.errorList.push(this.$t('an error occurred please try again later'))
      }
    },
    resumeInput(resumeArray) {
      for (let i = 0; i < resumeArray.length; i++) {
        resumeArray[i].tags = ['resume']
      }

      this.form.attachments = resumeArray
    },
    showThread() {
      this.$emit('what-to-show', 'messages-only-opened')
    },
    handleTextAreaChange(value: string) {
      if (this.useStore) {
        this.$set(this.form, 'body', value)
        this.setContactFormData(this.form)
      }
    },
    handleChangeFormField(tradeFields: { [key: string]: number | string }) {
      this.form = toSnakeCase({ ...this.form, ...tradeFields })
    }
  },
  i18n: defineComponentTranslations({
    message_template: {
      en:
        'I am interested in your {siteUrl} listing,\nwith classified number {siteUrl}/{classifiedId}\nPlease contact me.\n\n\n Best regards',
      el:
        'Ενδιαφέρομαι για την αγγελία σας,\nμε αριθμό {siteUrl}/{classifiedId}\nΠαρακαλώ επικοινωνήστε μαζί μου.\n\n\n Με εκτίμηση'
    },
    wanted_parts_message_template: {
      en:
        "I have the spare part you're looking for in the classified\nwith number {siteUrl}/{classifiedId}\nPlease contact me.\n\n\n Best regards",
      el:
        'Διαθέτω το ανταλλακτικό που ζητάτε στην αγγελία\nμε αριθμό {siteUrl}/{classifiedId}\nΠαρακαλώ επικοινωνήστε μαζί μου.\n\n\n Με εκτίμηση'
    }
  })
})
